module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAiklEQVR42t2QsQrCMBCG87Qu+lZuruLcRVz0DRQN1EkUSxVMau4+e3spoVPw4374ycEHF1cGB+eYkoIEDBE9dFcs1gcYEcQavjek2SDPtXV7yxRognDCkPceee3ACEfb5QhCP2dILfJYofclkho0XkA/eScoIO2W5BeIn/e9Qsf+wM0cE1KC4D/4AauGltemxDY/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TJ.png
// module id = 1279
// module chunks = 0